import bsCustomFileInput from 'bs-custom-file-input'

$(document).on('turbo:load', () => {
  bsCustomFileInput.init()
});
